import { render } from "./WorkStepsHome.vue?vue&type=template&id=98cb3fa4"
const script = {}

import "./WorkStepsHome.vue?vue&type=style&index=0&id=98cb3fa4&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__